import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { HasPermission } from '@iris-platform/protektor';
import applicationPropType from '../applicationPropType';
import Providers from './Providers';
import Settings from './Settings';
import SelfProvision from './SelfProvision';
import Redirects from './Redirects';
import { PROTEKTOR_VIEW } from '../../../utils/protektorConstants';


const styles = () => ({
  root: {
    '& [class^="MuiFormControl"]': {
      marginLeft: '12px',
    },
  },
  icon: {
    // margin: theme.spacing.unit,
    fontSize: 14,
    cursor: 'pointer',
  },
  iconbutton: {
    width: '18px',
    height: '18px',
  },
});

const AuthTab = ({
  application,
  refreshApp,
  ownerId,
  role,
}) => (
  <Fragment>
    <HasPermission
      to={PROTEKTOR_VIEW}
      access="Application_OAuth2_Tab_Login_Name"
      forRole={role}
    >
      <Settings
        appKey={application.clientID}
        application={application}
        refreshApp={refreshApp}
        ownerId={ownerId}
        role={role}
      />
    </HasPermission>
    <br />
    <br />
    <HasPermission
      to={PROTEKTOR_VIEW}
      access="Application_OAuth2_Tab_Redirect_URIs"
      forRole={role}
    >
      <Redirects
        appKey={application.clientID}
        application={application}
        refreshApp={refreshApp}
        ownerId={ownerId}
        role={role}
      />
    </HasPermission>
    <br />
    <br />
    <HasPermission
      to={PROTEKTOR_VIEW}
      access="Application_OAuth2_Tab_Self_Provisioning"
      forRole={role}
    >
      <SelfProvision
        appKey={application.clientID}
        application={application}
        refreshApp={refreshApp}
        ownerId={ownerId}
        role={role}
      />
    </HasPermission>
    <br />
    <br />
    <HasPermission
      to={PROTEKTOR_VIEW}
      access="Application_OAuth2_Tab_Providers"
      forRole={role}
    >
      <Providers
        appKey={application.clientID}
        application={application}
        refreshApp={refreshApp}
        ownerId={ownerId}
        role={role}
      />
    </HasPermission>
  </Fragment>
);

AuthTab.propTypes = {
  application: applicationPropType.isRequired,
  refreshApp: PropTypes.func.isRequired,
  ownerId: PropTypes.string.isRequired,
  role: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthTab);
